'use client';

import React, { createContext, useContext } from 'react';
import { useBondsCharts } from './useBondsCharts';

type BondsChartsContextType = ReturnType<typeof useBondsCharts>;

export const BondsChartsContext = createContext<BondsChartsContextType>(null);

export const useBondsChartsContext = () => {
  const context = useContext(BondsChartsContext);

  if (!context) {
    throw new Error('useBondsChartsContext must be used within the BondsChartsContext');
  }

  return context;
};

interface IProps {
  children: React.ReactNode,
}

const BondsChartsContextProvider = ({ children }:IProps) => (
  <BondsChartsContext.Provider value={ useBondsCharts() }>
    { children }
  </BondsChartsContext.Provider>
);

export default BondsChartsContextProvider;
